import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=624a5437&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=624a5437&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a5437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624a5437')) {
      api.createRecord('624a5437', component.options)
    } else {
      api.reload('624a5437', component.options)
    }
    module.hot.accept("./recharge.vue?vue&type=template&id=624a5437&scoped=true", function () {
      api.rerender('624a5437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serve/recharge.vue"
export default component.exports